"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unselectQuestion = exports.setSelectedQuestion = exports.highlightQuestion = exports.UNSELECT_QUESTION = exports.SET_SELECTED_QUESTION = exports.HIGHLIGHT_QUESTION = void 0;
var SET_SELECTED_QUESTION = exports.SET_SELECTED_QUESTION = 'SET_SELECTED_QUESTION';
var UNSELECT_QUESTION = exports.UNSELECT_QUESTION = 'UNSELECT_QUESTION';
var HIGHLIGHT_QUESTION = exports.HIGHLIGHT_QUESTION = 'HIGHLIGHT_QUESTION';

var setSelectedQuestion = exports.setSelectedQuestion = function setSelectedQuestion(selectedQuestion, selectedAnswer) {
  return {
    type: SET_SELECTED_QUESTION,
    selectedQuestionPayload: selectedQuestion,
    selectedAnswerPayload: selectedAnswer
  };
};

var unselectQuestion = exports.unselectQuestion = function unselectQuestion() {
  return {
    type: UNSELECT_QUESTION
  };
};

var highlightQuestion = exports.highlightQuestion = function highlightQuestion(selectedQuestion) {
  return {
    type: HIGHLIGHT_QUESTION,
    payload: selectedQuestion
  };
};